import { errorMessage } from '../api/client';
import { cn } from '../lib/utils';

/**
 * The one way an SPA shows a failure inline: the friendly message for any error
 * value (see {@link errorMessage}), announced to assistive tech, or nothing when
 * there is no error. Pass a plain string to show a message you composed.
 */
export function ErrorText({
  error,
  className,
}: {
  error: unknown;
  className?: string;
}) {
  const message = typeof error === 'string' ? error : errorMessage(error);
  if (!message) return null;
  return (
    <p role="alert" className={cn('text-sm text-destructive', className)}>
      {message}
    </p>
  );
}
